import { AuthSignInForm } from '@command-center/ui-system';
import { useAuth } from './AuthProvider';

export function SignInForm() {
  const { signIn, isConfigured, requestPasswordReset } = useAuth();

  return (
    <AuthSignInForm
      description="Use your Command Center account to access Cascade."
      configured={isConfigured}
      configurationMessage="Supabase browser configuration is missing."
      onSignIn={signIn}
      onForgotPassword={requestPasswordReset}
    />
  );
}
